import * as React from 'react';
import { extendTheme, styled } from '@mui/material/styles';
import Badge from '@mui/material/Badge';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import ManageAccounts from '@mui/icons-material/ManageAccounts';
import Settings from '@mui/icons-material/Settings';
import QueryStats from '@mui/icons-material/QueryStats';
import BarChartIcon from '@mui/icons-material/BarChart';
import DescriptionIcon from '@mui/icons-material/Description';
import Inventory from '@mui/icons-material/Inventory';
import LayersIcon from '@mui/icons-material/Layers';
import AgricultureIcon from '@mui/icons-material/Agriculture';
import Category from '@mui/icons-material/Category';
import PrecisionManufacturing from '@mui/icons-material/Agriculture';
import { AppProvider } from '@toolpad/core/AppProvider';
import { DashboardLayout } from '@toolpad/core/DashboardLayout';
import { PageContainer } from '@toolpad/core/PageContainer';
import Grid from '@mui/material/Grid2';
import {BrowserRouter as Router, Routes, Route, Link, useLocation, HashRouter, useNavigate} from "react-router-dom";
import ScrollToTop from '../pages/ScroolToTop';
import Dashboard from '../pages/Dashboard';
import Products from '../pages/Products';
import Supplychain from '../pages/Supplychain';
import Inventory_ from '../pages/Inventory';
import Warehouse from '../pages/Warehouse';
import Agent from '../pages/Agent';
import Traceability from '../pages/Traceability';
import Users from '../pages/Users';
import Farmer from '../pages/Farmer';
import Sales from '../pages/Sales';
import Staff from '../pages/Staff';
import Expenses from '../pages/Expenses';
import Cashsales from '../pages/Cashsales';
import Hauller from '../pages/Haller';
import Process from '../pages/Processingcenter';
import Services from '../pages/Services';
import Customer from '../pages/Customer';
import Commodity from '../pages/Commodity';
import Contract from '../pages/Contract';
import Requisition from '../pages/Requisition';
import Receivegoods from '../pages/Receive';
import Dispatchgoods from '../pages/Dispatch';
import Standardization from '../pages/Standardize';
import Pprocess from '../pages/Pprocess';

import Mechanization from '../pages/Mechanization';
import EngineeringIcon from '@mui/icons-material/Engineering';
import FactoryIcon from '@mui/icons-material/Factory';
import GroupsIcon from '@mui/icons-material/Groups';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import MonetizationOnOutlinedIcon from '@mui/icons-material/MonetizationOnOutlined';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import FaceRetouchingNaturalIcon from '@mui/icons-material/FaceRetouchingNatural';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import MiscellaneousServicesIcon from '@mui/icons-material/MiscellaneousServices';
import LogoutIcon from '@mui/icons-material/Logout';
import InputIcon from '@mui/icons-material/Input';
import CreditScoreIcon from '@mui/icons-material/CreditScore';
import TireRepairIcon from '@mui/icons-material/TireRepair';
import HandshakeIcon from '@mui/icons-material/Handshake';
import ReportIcon from '@mui/icons-material/Report';
import CallReceivedIcon from '@mui/icons-material/CallReceived';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import RunningWithErrorsIcon from '@mui/icons-material/RunningWithErrors';
import BalanceIcon from '@mui/icons-material/Balance';
import Logo from '../assets/playstore.png'
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { getadmin } from '../redux/admin';
import { getcustomer } from '../redux/customer';
import { getcommodity } from '../redux/commodity';
import { getcontract } from '../redux/contract';
import { getfarmer } from '../redux/farmer';
import { gethauller } from '../redux/hauller';
import { getprocessingcenter } from '../redux/processingcenter';
import { getsales } from '../redux/sales';
import { getservice } from '../redux/service';
import { getstaff } from '../redux/staff';
import { getwarehouse } from '../redux/warehouse';
import { getpurchase } from '../redux/purchase';
import { getexpenses } from '../redux/expenses';
import { getagent } from '../redux/agent';
import { getstock } from '../redux/stock';
import { getcashsales } from '../redux/cashsales';
import { getmechanization } from '../redux/mechanization';

import axios from 'axios';
import { Button } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

const hasPermission = (requiredPermission, userPermissions, adminData) => {
  // Super admin has all permissions
  if (adminData?.role === 'super_admin') {
    return true;
  }
  
  // Check if user has the required permission
  if (userPermissions?.permissions && Array.isArray(userPermissions.permissions)) {
    return userPermissions.permissions.includes(requiredPermission);
  }
  
  return false;
};

// Filter navigation items based on permissions
const getFilteredNavigation = (userPermissions, adminData, pusher) => {
  const baseNavigation = [
    {
      kind: 'header',
      title: 'Main items',
    },
    
    {
      segment: 'dashboard',
      title: 'Dashboard',
      icon: <DashboardIcon />,
    },
    {
      segment: 'data',
      title: 'Data Management',
      icon: <BarChartIcon />,
      children: [
        {
          segment: 'services',
          title: 'Services',
          icon: <MiscellaneousServicesIcon />,
          permission: 'Allow Services'
        },
        {
          segment: 'farmer',
          title: 'Farmer',
          icon: <EngineeringIcon/>,
          permission: 'Allow Add Farmer'
        },
        {
          segment: 'customer',
          title: 'Customer',
          icon: <FaceRetouchingNaturalIcon/>,
          permission: 'Allow Customer'
        },
        {
          segment: 'agent',
          title: 'Agents',
          icon: <SupportAgentIcon/>,
          permission: 'Allow Agent'
        },
        {
          segment: 'haullier',
          title: 'Haullier',
          icon: <SupportAgentIcon/>,
          permission: 'Allow Haullier'
        },
        {
          segment: 'Staff',
          title: 'Staff',
          icon: <GroupsIcon/>,
          permission: 'Allow Staff'
        },
        {
          segment: 'warehouse',
          title: 'Warehouse',
          icon: <WarehouseIcon />,
          permission: 'Allow Warehouse'
        },
        {
          segment: 'processingcenter',
          title: 'Processing Center',
          icon: <FactoryIcon/>,
          permission: 'Allow Processing Center'
        },
      ],
    },
    {
      segment: 'supply',
      title: 'Supply Chain',
      icon: <PrecisionManufacturingIcon />,
      children: [
        {
          segment: 'commodityaggregation',
          title: 'Sourcing',
          icon: <Badge badgeContent={pusher.length} color="secondary">
            <TireRepairIcon/>
          </Badge>,
          permission: 'Allow Sourcing'
        },
        {
          segment: 'Sales',
          title: 'Producce Sales',
          icon: <CreditScoreIcon/>,
          permission: 'Allow Sales'
        },
        {
          segment: 'Cashsales',
          title: 'Input Sales',
          icon: <MonetizationOnOutlinedIcon/>,
          permission: 'Allow Input Sales'
        },
        {
          segment: 'Mechanization',
          title: 'Mechanization',
          icon: <PrecisionManufacturingIcon/>,
          permission: 'Allow Mechanization'
        }
      ],
    },
    {
      segment: 'inventory',
      title: 'Inventory Management',
      icon: <Inventory />,
      children: [
        {
          segment: 'receivegoods',
          title: 'Received Raw Goods',
          icon: <CallReceivedIcon/>,
          permission: 'Allow Inventory'
        },
        {
          segment: 'receivedfinish',
          title: 'Received Finished Goods',
          icon: <BalanceIcon/>,
          permission: 'Allow Inventory'
        },
        {
          segment: 'dispatchgoods',
          title: 'Dispatched Goods',
          icon: <LocalShippingIcon/>,
          permission: 'Allow Inventory'
        },
      ],
    },
    {
      segment: 'contract',
      title: 'Contract Farming',
      icon: <HandshakeIcon />,
      permission: 'Allow Input Requisition'
    },
    {
      segment: 'expenses',
      title: 'Expenditure',
      icon: <CurrencyExchangeIcon />,
      permission: 'Allow Expenses'
    },
    {
      kind: 'divider',
    },
    {
      segment: 'logout',
      title: 'Logout',
      icon: <LogoutIcon />,
    },
  ];

  // If admin is super_admin, show all menu items
  if (adminData?.role === 'super_admin') {
    return baseNavigation;
  }

  // Filter navigation items based on permissions
  const filterNavigationItem = (item) => {
    // Always show headers, dividers, and logout
    if (item.kind === 'header' || item.kind === 'divider' || item.segment === 'logout' || item.segment === 'dashboard') {
      return true;
    }

    // Check if item has permission requirement
    if (item.permission) {
      return hasPermission(item.permission, userPermissions, adminData);
    }

    // For items with children, filter children and only show if at least one child is visible
    if (item.children && Array.isArray(item.children)) {
      const filteredChildren = item.children.filter(child => {
        if (child.permission) {
          return hasPermission(child.permission, userPermissions, adminData);
        }
        return true;
      });
      
      // Only show parent if it has visible children
      return filteredChildren.length > 0;
    }

    // If no permission specified, show by default
    return true;
  };

  return baseNavigation.filter(filterNavigationItem).map(item => {
    if (item.children && Array.isArray(item.children)) {
      return {
        ...item,
        children: item.children.filter(child => {
          if (child.permission) {
            return hasPermission(child.permission, userPermissions, adminData);
          }
          return true;
        })
      };
    }
    return item;
  });
};

const demoTheme = extendTheme({
  colorSchemes: { light: true, dark: true },
  colorSchemeSelector: 'class',
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 600,
      lg: 1200,
      xl: 1536,
    },
  },
});



function useDemoRouter(initialPath) {
  const [pathname, setPathname] = React.useState(initialPath);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
   
  const router = React.useMemo(() => {
    return {
      pathname: location.pathname,
      searchParams: new URLSearchParams(),
      navigate: (path) => {
        if (path === '/logout') {
          // Clear local storage
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          
          // Clear Redux state
          dispatch({ type: 'auth/logoutSuccess' });
          
          // Remove auth header from axios
          delete axios.defaults.headers.common['x-auth-token'];
          
          // Force reload and redirect
          window.location.href = '/login';
        } else {
          navigate(path);
        }
      },
    };
  }, [location.pathname, navigate]);

  return router;
}

const Skeleton = styled('div')(({ theme, height }) => ({
  backgroundColor: theme.palette.action.hover,
  borderRadius: theme.shape.borderRadius,
  height,
  content: '" "',
}));

// Add LogoutButton component
const LogoutButton = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    // Clear local storage
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    
    // Clear Redux state
    dispatch({ type: 'auth/logoutSuccess' });
    
    // Remove auth header from axios
    delete axios.defaults.headers.common['x-auth-token'];
    
    // Force reload and redirect
    window.location.replace('/login');
  };

  return (
    <Button
      onClick={handleLogout}
      startIcon={<LogoutIcon />}
      sx={{ 
        width: '100%', 
        justifyContent: 'flex-start',
        color: 'inherit',
        textTransform: 'none',
        padding: '8px 16px'
      }}
    >
      Logout
    </Button>
  );
};

export default function AppRouter() {
  const router = useDemoRouter('/dashboard');
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const dt = new Date()
  const time = dt.getHours() + ":" + dt.getMinutes() + ":" + dt.getSeconds();
  const day = dt.getUTCDate();
  const month = String(dt.getMonth() + 1).padStart(2, '0');
  const year = dt.getFullYear();
  const date = year + "-" + month + "-" + day;
  const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]

  var pusher = []

  const admin = useSelector((state) => state.admin)
  const rows = useSelector((state) => state.commodity)

  const [loading, setLoading] = React.useState(true);

  const gettingcommodity = async () => {
    try {
      await axios.post("https://embert.sisrevolution.com/api/commodity/getcommodity/", {})
        .then(res => {
          if (res.status === 200) {
            dispatch(getcommodity({ data: res.data }));
          }
        });
    } catch (err) {
      // Optionally log error
      // console.error("Error fetching commodity", err);
    }
    // Always resolve
    return Promise.resolve();
  };

  
  const gettingfarmer = async () => {
        
    try{

      await axios.post("https://embert.sisrevolution.com/api/farmer/getfarmer/",
        {
                        

        }).then(res => {

            if (res.status === 200) {
            console.log(res)
            dispatch(getfarmer({
                 data: res.data
                
                                  }))
            } else {
                // setloading(false)
            }

        })
      }catch(err){
        // setloading(false)
       
}
}


  
  const gettingservice = async () => {
        
    try{

      await axios.post("https://embert.sisrevolution.com/api/service/getservice/",
        {
                        

        }).then(res => {

            if (res.status === 200) {
            console.log(res)
            dispatch(getservice({
                 data: res.data
                
                                  }))
            } else {
                // setloading(false)
            }

        })
      }catch(err){
        // setloading(false)
       
}
}

  
  const gettingcustomer = async () => {
        
    try{

      await axios.post("https://embert.sisrevolution.com/api/customer/getcustomer/",
        {
                        

        }).then(res => {

            if (res.status === 200) {
            console.log(res)
            dispatch(getcustomer({
                 data: res.data
                
                                  }))
            } else {
                // setloading(false)
            }

        })
      }catch(err){
        // setloading(false)
       
}
}

  
  const gettinghaullier = async () => {
        
    try{

      await axios.post("https://embert.sisrevolution.com/api/haullier/gethaullier/",
        {
                        

        }).then(res => {

            if (res.status === 200) {
            console.log(res)
            dispatch(gethauller({
                 data: res.data
                
                                  }))
            } else {
                // setloading(false)
            }

        })
      }catch(err){
        // setloading(false)
       
}
}

  
  const gettingwarehouse = async () => {
        
    try{

      await axios.post("https://embert.sisrevolution.com/api/warehouse/getwarehouse/",
        {
                        

        }).then(res => {

            if (res.status === 200) {
            console.log(res)
            dispatch(getwarehouse({
                 data: res.data
                
                                  }))
            } else {
                // setloading(false)
            }

        })
      }catch(err){
        // setloading(false)
       
}
}

  
  const gettingprocessingcenter = async () => {
        
    try{

      await axios.post("https://embert.sisrevolution.com/api/center/getprocessingcenter/",
        {
                        

        }).then(res => {

            if (res.status === 200) {
            console.log(res)
            dispatch(getprocessingcenter({
                 data: res.data
                
                                  }))
            } else {
                // setloading(false)
            }

        })
      }catch(err){
        // setloading(false)
       
}
}

 
  const gettingsales = async () => {
        
    try{

      await axios.post("https://embert.sisrevolution.com/api/sales/getsales/",
        {
                        

        }).then(res => {

            if (res.status === 200) {
            console.log(res)
            dispatch(getsales({
                 data: res.data
                
                                  }))
            } else {
                // setloading(false)
            }

        })
      }catch(err){
        // setloading(false)
       
}
}
 
  const gettingagent = async () => {
        
    try{

      await axios.post("https://embert.sisrevolution.com/api/agent/getagent/",
        {
                        

        }).then(res => {

            if (res.status === 200) {
            console.log(res)
            dispatch(getagent({
                 data: res.data
                
                                  }))
            } else {
                // setloading(false)
            }

        })
      }catch(err){
        // setloading(false)
       
}
}


  const gettingcontract = async () => {
        
    try{

      await axios.post("https://embert.sisrevolution.com/api/contract/getcontract/",
        {
                        

        }).then(res => {

            if (res.status === 200) {
            console.log(res)
            dispatch(getcontract({
                 data: res.data
                
                                  }))
            } else {
                // setloading(false)
            }

        })
      }catch(err){
        // setloading(false)
       
}
}
 
  const gettingrequisition = async () => {
        
    try{

      await axios.post("https://embert.sisrevolution.com/api/requisition/getrequisition/",
        {
                        

        }).then(res => {

            if (res.status === 200) {
            console.log(res)
            dispatch(getcontract({
                 data: res.data
                
                                  }))
            } else {
                // setloading(false)
            }

        })
      }catch(err){
        // setloading(false)
       
}
}

 
  const gettingpurchase = async () => {
        
    try{

      await axios.post("https://embert.sisrevolution.com/api/purchase/getpurchase/",
        {
                        

        }).then(res => {

            if (res.status === 200) {
            console.log(res)
            dispatch(getpurchase({
                 data: res.data
                
                                  }))
            } else {
                // setloading(false)
            }

        })
      }catch(err){
        // setloading(false)
       
}
}



  const gettingstaff = async () => {
        
    try{

      await axios.post("https://embert.sisrevolution.com/api/staff/getstaff/",
        {
                        

        }).then(res => {

            if (res.status === 200) {
            console.log(res)
            dispatch(getstaff({
                 data: res.data
                
                                  }))
            } else {
                // setloading(false)
            }

        })
      }catch(err){
        // setloading(false)
       
}
}


const gettingexpenses = async () => {
  
        
    await axios.post("https://embert.sisrevolution.com/api/expenses/getexpenses/",
        {
            // schoolID:admin.schoolID

        }).then(res => {
       
            if (res.status === 200) {
              console.log("exp")
              console.log(res)
                dispatch(getexpenses({

                    data: res.data

                }))


            }

        })

}


const gettingstock = async () => {
  
        
    await axios.post("https://embert.sisrevolution.com/api/stock/getstock/",
        {
            // schoolID:admin.schoolID

        }).then(res => {
       
            if (res.status === 200) {
                dispatch(getstock({

                    data: res.data

                }))


            }

        })

}


const gettingcashsales = async () => {
  
        
    await axios.post("https://embert.sisrevolution.com/api/cashsales/getcashsales/",
        {
            // schoolID:admin.schoolID

        }).then(res => {
       
            if (res.status === 200) {
                dispatch(getcashsales({

                    data: res.data

                }))


            }

        })

}


const gettingmechanization = async () => {
  
  console.log("mechanization 2")

    await axios.post("https://embert.sisrevolution.com/api/mechanization/getmechanization/",
        {
            // schoolID:admin.schoolID

        }).then(res => {
          
            if (res.status === 200) {
                dispatch(getmechanization({

                    data: res.data

                }))


            }

        })

}




  React.useEffect(() => { 
    const loadAllData = async () => {
      setLoading(true);
      
      // Set a maximum loading time of 3 seconds
      const loadingTimeout = setTimeout(() => {
        setLoading(false);
      }, 3000);
      
      try {
        // Load all data in parallel for faster loading
        await Promise.all([
          gettingfarmer().catch(() => {}),
          gettingcommodity().catch(() => {}),
          gettingcustomer().catch(() => {}),
          gettinghaullier().catch(() => {}),
          gettingservice().catch(() => {}),
          gettingwarehouse().catch(() => {}),
          gettingsales().catch(() => {}),
          gettingcashsales().catch(() => {}),
          gettingstock().catch(() => {}),
          gettingcontract().catch(() => {}),
          gettingstaff().catch(() => {}),
          gettingprocessingcenter().catch(() => {}),
          gettingrequisition().catch(() => {}),
          gettingpurchase().catch(() => {}),
          gettingagent().catch(() => {}),
          gettingexpenses().catch(() => {}),
          gettingmechanization().catch(() => {})
        ]);
        
        // Clear the timeout and turn off loader
        clearTimeout(loadingTimeout);
        setLoading(false);
      } catch (error) {
        // Clear the timeout and ensure loader is turned off even if there's an error
        clearTimeout(loadingTimeout);
        setLoading(false);
      }
    };
    loadAllData();
  }, []);

  React.useEffect(() => {
    navigate(router.pathname);
  }, [router, navigate]);

  // if (loading) {
  //   return (
  //     <div style={{
  //       display: 'flex',
  //       justifyContent: 'center',
  //       alignItems: 'center',
  //       height: '100vh',
  //       width: '100vw',
  //       position: 'fixed',
  //       top: 0,
  //       left: 0,
  //       background: 'rgba(0, 0, 0, 0.1)', // semi-transparent dark background
  //       zIndex: 1300 // above most UI
  //     }}>
  //       <CircularProgress size={60} />
  //     </div>
  //   );
  // }

const handleLogout = () => {
  // Clear local storage
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  
  // Clear Redux state
  dispatch({ type: 'auth/logoutSuccess' });
  
  // Remove auth header from axios
  delete axios.defaults.headers.common['x-auth-token'];
  
  // Navigate to login page
  navigate('/login');
};




const NAVIGATION = getFilteredNavigation(JSON.parse(localStorage.getItem('user') || '{}'), admin, pusher);




  // Remove this const when copying and pasting into your project.
  const demoWindow = typeof window !== 'undefined' ? window : undefined;

  // Add click handler for navigation
  const handleNavigation = (segment) => {
    router.navigate(`/${segment}`);
  };

  return (
   
      
 
    <AppProvider
      navigation={NAVIGATION}
      router={router}
      onNavigation={handleNavigation}
      branding={{
        logo: <img src={Logo} alt="MUI logo" />,
        title: 'Agrotracis ERP',
        subtitle: location.pathname.replace('/', '').split('/').map(word => 
          word.charAt(0).toUpperCase() + word.slice(1)
        ).join(' > ') || 'Dashboard'
      }}
      theme={demoTheme}
      window={demoWindow}
    >
      <DashboardLayout>
        {loading && <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        width: '100vw',
        position: 'fixed',
        top: 0,
        left: 0,
        background: 'rgba(0, 0, 0, 0.5)', // semi-transparent dark background
        zIndex: 1300 // above most UI
      }}>
        <CircularProgress size={60} />
      </div>}
        <PageContainer>


        <ScrollToTop />
                
                <Routes>
               
                
                    <Route path="/" element={<Dashboard/>} />
                    <Route path="/dashboard" element={<Dashboard/>} />
                    <Route path="/data/products" element={<Products/>} />
                    <Route path="supply" element={<Supplychain/>} />
                    {/* <Route path="mechanization" element={<Mechanization/>} /> */}
                    <Route path="contract" element={<Contract/>} />
                    <Route path="/data/agent" element={<Agent/>} />
                    <Route path="/data/farmer" element={<Farmer/>} />
                    <Route path="/supply/inventory" element={<Inventory_/>} />
                    <Route path="/supply/requisition" element={<Requisition/>} />
                    <Route path="/data/warehouse" element={<Warehouse/>} />
                    <Route path="/data/services" element={<Services/>} />
                    <Route path="/data/haullier" element={<Hauller/>} />
                    <Route path="/data/staff" element={<Staff/>} />
                    <Route path="/inventory/receivegoods" element={<Receivegoods/>} />
                    <Route path="/inventory/dispatchgoods" element={<Dispatchgoods/>} />
                    <Route path="/inventory/receivedfinish" element={<Standardization/>} />
                    <Route path="/inventory/pprocess" element={<Pprocess/>} />
                    <Route path="/data/customer" element={<Customer/>} />
                    <Route path="/supply/sales" element={<Sales/>} />
                    <Route path="/supply/cashsales" element={<Cashsales/>} />
                    <Route path="/supply/mechanization" element={<Mechanization/>} />
                    <Route path="/supply/commodityaggregation" element={<Commodity/>} />
                    <Route path="/expenses" element={<Expenses/>} />
                    <Route path="/data/processingcenter" element={<Process/>} />
                    <Route path="/traceability" element={<Traceability/>} />
                    <Route path="/users" element={<Users/>} />
                    <Route path="/settings" element={<Settings/>} />
                    
                    
                </Routes>
            

         
        </PageContainer>
      </DashboardLayout>
    </AppProvider>
    
  );
}
